import { useSearchParams } from "react-router-dom";
import { useGetApi } from "src/hooks";

import { mapRevAud } from "./RevAud.utils";

const useGetRevAud = (request: string) => {
  const [searchParams] = useSearchParams();
  const { data, refetch, isLoading } = useGetApi({
    request,
    ...(searchParams.get("sort") && searchParams.get("dir")
      ? {
          body: {
            params: {
              sort: searchParams.get("sort"),
              dir: searchParams.get("dir"),
            },
          },
        }
      : {}),
    mapper: mapRevAud,
  });
  return { data, refetch, isLoading };
};
export default useGetRevAud;
